import { api } from "@/lib/api/client"
import type { BaseResponse } from "@/types/api"

import type { DashboardSummary } from "./types"

export async function getDashboardSummary(): Promise<DashboardSummary> {
  const { data } = await api.get<BaseResponse<DashboardSummary>>(
    "/exporter/dashboard/summary",
  )
  if (!data.success || !data.result) {
    throw new Error(data.message ?? "Could not load dashboard summary")
  }
  return data.result
}
